export const trafficSigns = [
  {
    id: "ts-1",
    lat: 44.423090563996475,
    lng: 8.885621448679046,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-2",
    lat: 44.422777961685185,
    lng: 8.885700997469797,
    type: "divieto-accesso",
    description: "Divieto accesso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-3",
    lat: 44.4228802461293,
    lng: 8.885201721290226,
    type: "stop",
    description: "Stop",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-4",
    lat: 44.42289430380301,
    lng: 8.885198449047016,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-5",
    lat: 44.42289279531988,
    lng: 8.885197609978588,
    type: "stop",
    description: "Stop",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-6",
    lat: 44.42301413675309,
    lng: 8.885218330517137,
    type: "stop",
    description: "Stop",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-7",
    lat: 44.4230154728826,
    lng: 8.88521996314539,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-8",
    lat: 44.42198358765285,
    lng: 8.884764879022077,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-9",
    lat: 44.42223302518262,
    lng: 8.884578422691028,
    type: "divieto-accesso",
    description: "Divieto accesso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-10",
    lat: 44.421817249824045,
    lng: 8.884726026293352,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-11",
    lat: 44.42203836198096,
    lng: 8.884818282138749,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-12",
    lat: 44.42219426159314,
    lng: 8.88480652317013,
    type: "no_entry.png",
    description: "Obbligo direzione diritto dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-13",
    lat: 44.422248729180126,
    lng: 8.884835010760993,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-14",
    lat: 44.42221207248632,
    lng: 8.8848227131477,
    type: "no_entry.png",
    description: "Obbligo direzione diritto dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-15",
    lat: 44.422111285650296,
    lng: 8.884855440608108,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-16",
    lat: 44.42226100354879,
    lng: 8.884843069542926,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-17",
    lat: 44.422215951385965,
    lng: 8.884806287877696,
    type: "no_entry.png",
    description: "Obbligo direzione diritto dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-18",
    lat: 44.42226187755289,
    lng: 8.88483146784751,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-19",
    lat: 44.42212028418662,
    lng: 8.884825474824504,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-20",
    lat: 44.42211798352232,
    lng: 8.88468845861875,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-21",
    lat: 44.422127181138244,
    lng: 8.884751811334446,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-22",
    lat: 44.422093317195646,
    lng: 8.884862177656807,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-23",
    lat: 44.42226321465046,
    lng: 8.884803965996783,
    type: "divieto-accesso",
    description: "Divieto accesso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-24",
    lat: 44.42223048105836,
    lng: 8.884815380976358,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-25",
    lat: 44.42211967840033,
    lng: 8.88470834302792,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-26",
    lat: 44.42213902656188,
    lng: 8.884773899365713,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-27",
    lat: 44.42217804152568,
    lng: 8.884657869425983,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-28",
    lat: 44.422174029746984,
    lng: 8.88465076768008,
    type: "stop",
    description: "Stop",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-29",
    lat: 44.4222290351718,
    lng: 8.88481584935981,
    type: "no_entry.png",
    description: "Obbligo direzione diritto dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-30",
    lat: 44.42218064792783,
    lng: 8.884654425630712,
    type: "stop",
    description: "Stop",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-31",
    lat: 44.422180946974166,
    lng: 8.884655264858845,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-32",
    lat: 44.42214789656764,
    lng: 8.884773860008039,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-33",
    lat: 44.422135141216934,
    lng: 8.884713213280689,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-34",
    lat: 44.42218960468847,
    lng: 8.884772806266811,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-35",
    lat: 44.42219548995201,
    lng: 8.884655340873584,
    type: "stop",
    description: "Stop",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-36",
    lat: 44.42219581818352,
    lng: 8.884656236835616,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-37",
    lat: 44.42215089671189,
    lng: 8.884706017748078,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-38",
    lat: 44.422189208703564,
    lng: 8.884653581407475,
    type: "stop",
    description: "Stop",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-39",
    lat: 44.42215260171919,
    lng: 8.884711510163537,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-40",
    lat: 44.422189676063454,
    lng: 8.884655448403755,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-41",
    lat: 44.42219759399897,
    lng: 8.884662639389047,
    type: "stop",
    description: "Stop",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-42",
    lat: 44.42219089358556,
    lng: 8.884716247213051,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-43",
    lat: 44.42219089358556,
    lng: 8.884716247213051,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-44",
    lat: 44.42216329266931,
    lng: 8.884921039268178,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-45",
    lat: 44.42216420327564,
    lng: 8.884741792594411,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-46",
    lat: 44.42231404757997,
    lng: 8.884717003648644,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-47",
    lat: 44.42217772765737,
    lng: 8.884535825604175,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-48",
    lat: 44.42219407596381,
    lng: 8.88452098452785,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-49",
    lat: 44.42232450840026,
    lng: 8.884618758431031,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-50",
    lat: 44.42231556334184,
    lng: 8.884598085020821,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-51",
    lat: 44.42231687981663,
    lng: 8.884599180371083,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-52",
    lat: 44.422327003984506,
    lng: 8.884796177120588,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-53",
    lat: 44.42223203259491,
    lng: 8.884520617926944,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-54",
    lat: 44.42229357092715,
    lng: 8.884039037445945,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-55",
    lat: 44.422306222003314,
    lng: 8.884067138995098,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-56",
    lat: 44.42230638475406,
    lng: 8.884061986294808,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-57",
    lat: 44.42230122071676,
    lng: 8.884097882572624,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-58",
    lat: 44.42217360936452,
    lng: 8.883847180236708,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-59",
    lat: 44.422256218132624,
    lng: 8.88386412507735,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-60",
    lat: 44.42230477802254,
    lng: 8.883868376016999,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-61",
    lat: 44.42230518912762,
    lng: 8.88376301753599,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-62",
    lat: 44.42229513721266,
    lng: 8.883876835944449,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-63",
    lat: 44.422288687843285,
    lng: 8.883785989256262,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-64",
    lat: 44.42217607621266,
    lng: 8.88393814369905,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-65",
    lat: 44.42211411105944,
    lng: 8.883926776614373,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-66",
    lat: 44.42215356114913,
    lng: 8.883905625512334,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-67",
    lat: 44.42209005464307,
    lng: 8.88388528832314,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-68",
    lat: 44.42211919306111,
    lng: 8.883806080589155,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-69",
    lat: 44.42213509317402,
    lng: 8.883817864612759,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-70",
    lat: 44.421850977498075,
    lng: 8.883063771308425,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-71",
    lat: 44.42187893210913,
    lng: 8.88308069187836,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-72",
    lat: 44.42178082502561,
    lng: 8.882921573024646,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-73",
    lat: 44.42178543465673,
    lng: 8.882931070418532,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-74",
    lat: 44.421785350111364,
    lng: 8.882960951681609,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-75",
    lat: 44.421788451785226,
    lng: 8.882964457666592,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-76",
    lat: 44.421482856602246,
    lng: 8.882679009471776,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-77",
    lat: 44.42150235452171,
    lng: 8.882331901506484,
    type: "divieto-accesso",
    description: "Divieto accesso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-78",
    lat: 44.420746399617215,
    lng: 8.88084188477225,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-79",
    lat: 44.420831299674106,
    lng: 8.880910169930226,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-80",
    lat: 44.42085736964778,
    lng: 8.881036250274382,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-81",
    lat: 44.42084355775685,
    lng: 8.881005690444729,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-82",
    lat: 44.42087616145394,
    lng: 8.881055700046401,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-83",
    lat: 44.42086410627815,
    lng: 8.88102841097002,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-84",
    lat: 44.42083071372217,
    lng: 8.881251592611596,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-85",
    lat: 44.42089860823052,
    lng: 8.881089024864332,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-86",
    lat: 44.42089155432097,
    lng: 8.881071862729462,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-87",
    lat: 44.42090871386077,
    lng: 8.881089169138297,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-88",
    lat: 44.420902235178815,
    lng: 8.881070823246077,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-89",
    lat: 44.42064871214954,
    lng: 8.880931644136087,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-90",
    lat: 44.420884518683465,
    lng: 8.880994793456297,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-91",
    lat: 44.420888652592886,
    lng: 8.881015258160005,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-92",
    lat: 44.420731994651,
    lng: 8.880575884109463,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-93",
    lat: 44.42065536354032,
    lng: 8.880884555323677,
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-94",
    lat: 44.420681889011895,
    lng: 8.88094650806913,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-95",
    lat: 44.42071226757186,
    lng: 8.880637578671687,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-96",
    lat: 44.420508941465265,
    lng: 8.880941030354167,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-97",
    lat: 44.4207612833644,
    lng: 8.880857088544966,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-98",
    lat: 44.420600589766046,
    lng: 8.880683857539251,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-99",
    lat: 44.420608058020825,
    lng: 8.880689350791041,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-100",
    lat: 44.42062414717896,
    lng: 8.880699632524868,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-101",
    lat: 44.420630427797306,
    lng: 8.880694530825519,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-102",
    lat: 44.42035037019486,
    lng: 8.880384057137457,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-103",
    lat: 44.420457952231686,
    lng: 8.880471245562576,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-104",
    lat: 44.42039549188735,
    lng: 8.88043259171283,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-105",
    lat: 44.42040268529381,
    lng: 8.880437058691191,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-106",
    lat: 44.420398226049784,
    lng: 8.880444155480573,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-107",
    lat: 44.42040504461306,
    lng: 8.88044704846057,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-108",
    lat: 44.42023850600956,
    lng: 8.880341932507148,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-109",
    lat: 44.420258893196774,
    lng: 8.880324234380955,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-110",
    lat: 44.41980999796841,
    lng: 8.879883384795955,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-111",
    lat: 44.419820655850714,
    lng: 8.879887165579605,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-112",
    lat: 44.419692896428344,
    lng: 8.879814079869242,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-113",
    lat: 44.4198152353324,
    lng: 8.879898355322243,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-114",
    lat: 44.41973827227045,
    lng: 8.879796231844303,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-115",
    lat: 44.41942637687037,
    lng: 8.87950699143856,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-116",
    lat: 44.41942688651403,
    lng: 8.879506033246516,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-117",
    lat: 44.41943013708174,
    lng: 8.879523178663476,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-118",
    lat: 44.41908989037606,
    lng: 8.878985087974401,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-119",
    lat: 44.41909978702058,
    lng: 8.87900868175159,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-120",
    lat: 44.41903891155949,
    lng: 8.878884883635338,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-121",
    lat: 44.41911500184139,
    lng: 8.879034779125446,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-122",
    lat: 44.41905496112092,
    lng: 8.878886552504339,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-123",
    lat: 44.41912816456719,
    lng: 8.879038251326016,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-124",
    lat: 44.41905675457813,
    lng: 8.878892193344866,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-125",
    lat: 44.41899649971864,
    lng: 8.879041710422133,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-126",
    lat: 44.41907114913973,
    lng: 8.878900806545676,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-127",
    lat: 44.41913537342973,
    lng: 8.879039508262828,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-128",
    lat: 44.419068127357356,
    lng: 8.878892842045648,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-129",
    lat: 44.41900641830516,
    lng: 8.879037222531801,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-130",
    lat: 44.419143640360595,
    lng: 8.879047064974914,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-131",
    lat: 44.419021805792234,
    lng: 8.879051107475311,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-132",
    lat: 44.419090866248396,
    lng: 8.878936220222743,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-133",
    lat: 44.41909075285392,
    lng: 8.878936304132068,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-134",
    lat: 44.419086544526486,
    lng: 8.878950071242203,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-135",
    lat: 44.419141219184326,
    lng: 8.879049394697908,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-136",
    lat: 44.419082949602824,
    lng: 8.878942276831214,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-137",
    lat: 44.41903268902888,
    lng: 8.87907066581571,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-138",
    lat: 44.419149054259684,
    lng: 8.87905536094583,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-139",
    lat: 44.41909465326578,
    lng: 8.878943911420844,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-140",
    lat: 44.419099482109196,
    lng: 8.878957305676629,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-141",
    lat: 44.41904116916982,
    lng: 8.879069571824918,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-142",
    lat: 44.4190986142517,
    lng: 8.878951129910668,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-143",
    lat: 44.41909610138709,
    lng: 8.878944599621361,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-144",
    lat: 44.419107612937324,
    lng: 8.878956344282123,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-145",
    lat: 44.41910853337803,
    lng: 8.878964424910839,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-146",
    lat: 44.419118022441026,
    lng: 8.87895978950141,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-147",
    lat: 44.41911753588637,
    lng: 8.878958961476176,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-148",
    lat: 44.41917302720136,
    lng: 8.878785034422107,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-149",
    lat: 44.41922989677471,
    lng: 8.878853632555467,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-150",
    lat: 44.41914800742583,
    lng: 8.87918930383106,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-151",
    lat: 44.41914934530034,
    lng: 8.879196624192822,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-152",
    lat: 44.41915888979848,
    lng: 8.878777026250075,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-153",
    lat: 44.41908736968082,
    lng: 8.878783194909769,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-154",
    lat: 44.4190808273492,
    lng: 8.878777863267434,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-155",
    lat: 44.41919070341484,
    lng: 8.878803668029777,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-156",
    lat: 44.41931761778198,
    lng: 8.878758372839862,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-157",
    lat: 44.41980530126117,
    lng: 8.878711110727858,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-158",
    lat: 44.42012378853098,
    lng: 8.878645555153922,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-159",
    lat: 44.41965555276485,
    lng: 8.878718834591245,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-160",
    lat: 44.41980324548608,
    lng: 8.878687314609618,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-161",
    lat: 44.419885822375925,
    lng: 8.878647124093167,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-162",
    lat: 44.41988463162466,
    lng: 8.8786574092416,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-163",
    lat: 44.41997294072413,
    lng: 8.878643273371255,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-164",
    lat: 44.419866799237745,
    lng: 8.878653505115071,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-165",
    lat: 44.41996947893394,
    lng: 8.878635166602294,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-166",
    lat: 44.41981570921258,
    lng: 8.878736727799753,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-167",
    lat: 44.420266489619486,
    lng: 8.878579943908143,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-168",
    lat: 44.42025131664451,
    lng: 8.878571057257918,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-169",
    lat: 44.4203800945532,
    lng: 8.878551710232411,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-170",
    lat: 44.420344745246304,
    lng: 8.878563775922187,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-171",
    lat: 44.420626627179296,
    lng: 8.878505399521742,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-172",
    lat: 44.42126203642732,
    lng: 8.878644373369534,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-173",
    lat: 44.4211417991357,
    lng: 8.87860703998944,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-174",
    lat: 44.42114368292474,
    lng: 8.878625255325128,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-175",
    lat: 44.42113956700363,
    lng: 8.878625743230323,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-176",
    lat: 44.42110993770034,
    lng: 8.878620293232617,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-177",
    lat: 44.421112427763575,
    lng: 8.87861066463425,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-178",
    lat: 44.42110770471696,
    lng: 8.87860877950326,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-179",
    lat: 44.4215767967697,
    lng: 8.87884409103557,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-180",
    lat: 44.42183250684078,
    lng: 8.879103107217173,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-181",
    lat: 44.42179597928747,
    lng: 8.879087906560203,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-182",
    lat: 44.42177890954678,
    lng: 8.879075998771755,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-183",
    lat: 44.422562094836074,
    lng: 8.879665515477885,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-184",
    lat: 44.42236599462267,
    lng: 8.879530046682214,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-185",
    lat: 44.42229454431166,
    lng: 8.87949555087478,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-186",
    lat: 44.42229138433836,
    lng: 8.879491513693525,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-187",
    lat: 44.42247569886987,
    lng: 8.879655296012128,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-188",
    lat: 44.422474424134656,
    lng: 8.87966044133868,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-189",
    lat: 44.422463130356235,
    lng: 8.879660293987897,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-190",
    lat: 44.42353158711542,
    lng: 8.88172017969976,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-191",
    lat: 44.42394010834406,
    lng: 8.88204462347974,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-192",
    lat: 44.42390129865039,
    lng: 8.881807048367541,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-193",
    lat: 44.423890472578066,
    lng: 8.8818115340928,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-194",
    lat: 44.42388635996445,
    lng: 8.881990784814882,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-195",
    lat: 44.42386609930904,
    lng: 8.88195498027795,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-196",
    lat: 44.423869508140825,
    lng: 8.881954395302868,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-197",
    lat: 44.423858494690506,
    lng: 8.881956236134572,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-198",
    lat: 44.42386150298012,
    lng: 8.881955433122714,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-199",
    lat: 44.42420623137543,
    lng: 8.882400970241243,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-200",
    lat: 44.42420638694941,
    lng: 8.882400807028986,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-201",
    lat: 44.42462798013856,
    lng: 8.882517922078664,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-202",
    lat: 44.42457798008203,
    lng: 8.882533396491263,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-203",
    lat: 44.42456803679955,
    lng: 8.882518801126924,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-204",
    lat: 44.42455808365289,
    lng: 8.88251488688478,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-205",
    lat: 44.42453117325402,
    lng: 8.882552466851742,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-206",
    lat: 44.42477547269391,
    lng: 8.882656976031296,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-207",
    lat: 44.425072025750836,
    lng: 8.882684166672714,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-208",
    lat: 44.425041187756285,
    lng: 8.882694727154515,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-209",
    lat: 44.42503683334355,
    lng: 8.882711848169018,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-210",
    lat: 44.42501812486785,
    lng: 8.882709851103474,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-211",
    lat: 44.42518419508818,
    lng: 8.882744264114462,
    type: "pericolo-strettoia-dx",
    description: "Pericolo strettoia dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-212",
    lat: 44.425287853852026,
    lng: 8.882765639791167,
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-213",
    lat: 44.42526112925555,
    lng: 8.882764111896824,
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-214",
    lat: 44.425255968207786,
    lng: 8.88276892996514,
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-215",
    lat: 44.42525570821651,
    lng: 8.882771097533134,
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-216",
    lat: 44.42526088971483,
    lng: 8.882766300217575,
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-217",
    lat: 44.425345729253195,
    lng: 8.88284090005681,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-218",
    lat: 44.425337813521104,
    lng: 8.882835098844534,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-219",
    lat: 44.42561864232087,
    lng: 8.882684010849662,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-220",
    lat: 44.425600783502304,
    lng: 8.882695035730224,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-221",
    lat: 44.42633948450947,
    lng: 8.881812287033524,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-222",
    lat: 44.42623154752061,
    lng: 8.88188426967031,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-223",
    lat: 44.426197673998985,
    lng: 8.881897066493726,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-224",
    lat: 44.42615018747965,
    lng: 8.88191104846953,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-225",
    lat: 44.4261410030306,
    lng: 8.88192982846192,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-226",
    lat: 44.42618241170817,
    lng: 8.882014175463132,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-227",
    lat: 44.426197437485826,
    lng: 8.882085597135996,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-228",
    lat: 44.42619072294787,
    lng: 8.882088459512028,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-229",
    lat: 44.426183594723874,
    lng: 8.882100859956518,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-230",
    lat: 44.42615538609112,
    lng: 8.882249486617996,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-231",
    lat: 44.42611929968044,
    lng: 8.882280346813578,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-232",
    lat: 44.42616702761527,
    lng: 8.882001583988924,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-233",
    lat: 44.42616222156763,
    lng: 8.881983443400852,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-234",
    lat: 44.426159768834154,
    lng: 8.8819942300033,
    type: "divieto-sosta",
    description: "Divieto sosta",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-235",
    lat: 44.42686244460383,
    lng: 8.881847161344863,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-236",
    lat: 44.42684844095515,
    lng: 8.881809515559777,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-237",
    lat: 44.42682939531182,
    lng: 8.881859493052904,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-238",
    lat: 44.42682260538639,
    lng: 8.881843722305792,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-239",
    lat: 44.42723369361805,
    lng: 8.881986502090939,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-240",
    lat: 44.42714688828968,
    lng: 8.881946529407742,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-241",
    lat: 44.42710169206518,
    lng: 8.882089247272615,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-242",
    lat: 44.427137714261214,
    lng: 8.882015449478022,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-243",
    lat: 44.42703504578641,
    lng: 8.882091670655479,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-244",
    lat: 44.42711183636901,
    lng: 8.882003746601493,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-245",
    lat: 44.42702152528712,
    lng: 8.882079764892115,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-246",
    lat: 44.4271000276118,
    lng: 8.881943905570372,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-247",
    lat: 44.42703407174869,
    lng: 8.882039106988081,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-248",
    lat: 44.42756190340987,
    lng: 8.882427084755076,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-249",
    lat: 44.42750143769134,
    lng: 8.88236203213621,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-250",
    lat: 44.42746557120207,
    lng: 8.882321846903482,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-251",
    lat: 44.42746617121151,
    lng: 8.882326318377938,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-252",
    lat: 44.427451678654855,
    lng: 8.882317012192802,
    type: "divieto-sosta",
    description: "Divieto sosta",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-253",
    lat: 44.4276294351408,
    lng: 8.882512869156605,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-254",
    lat: 44.42761217668158,
    lng: 8.882486608294437,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-255",
    lat: 44.42761675735887,
    lng: 8.88248946571269,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-256",
    lat: 44.42763496812731,
    lng: 8.882444860524753,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-257",
    lat: 44.42761675862392,
    lng: 8.882439600805105,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-258",
    lat: 44.428580608648126,
    lng: 8.883310190851098,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-259",
    lat: 44.42866982127746,
    lng: 8.883380010076678,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-260",
    lat: 44.42857225667524,
    lng: 8.883301913239023,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-261",
    lat: 44.428646318656206,
    lng: 8.88338408421443,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-262",
    lat: 44.42864149327534,
    lng: 8.883367026301162,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-263",
    lat: 44.42879538656567,
    lng: 8.883740476370509,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-264",
    lat: 44.42879846274235,
    lng: 8.883730535930937,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-265",
    lat: 44.42879483728934,
    lng: 8.883728117919928,
    type: "divieto-sosta",
    description: "Divieto sosta",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-266",
    lat: 44.4292254481296,
    lng: 8.885516471777542,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-267",
    lat: 44.42923360136689,
    lng: 8.885467974923921,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-268",
    lat: 44.42955789702632,
    lng: 8.885963544803404,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-269",
    lat: 44.42954285800234,
    lng: 8.885945859565204,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-270",
    lat: 44.42963413612055,
    lng: 8.885879741778776,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-271",
    lat: 44.42954152567355,
    lng: 8.885941364042454,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-272",
    lat: 44.42962110685836,
    lng: 8.885877916508477,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-273",
    lat: 44.42988401494455,
    lng: 8.886474850992958,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-274",
    lat: 44.42979961934048,
    lng: 8.886416616212136,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-275",
    lat: 44.42981350308536,
    lng: 8.886399616317606,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-276",
    lat: 44.429792437044966,
    lng: 8.886368831386715,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-277",
    lat: 44.43026768853912,
    lng: 8.886758661476506,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-278",
    lat: 44.4305218456225,
    lng: 8.88672796083419,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-279",
    lat: 44.43121025922696,
    lng: 8.88686936090399,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-280",
    lat: 44.43119804495455,
    lng: 8.886881820017186,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-281",
    lat: 44.4311710847116,
    lng: 8.886899333594565,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-282",
    lat: 44.432114049991476,
    lng: 8.886117547104169,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-283",
    lat: 44.432245754629584,
    lng: 8.886079000904635,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-284",
    lat: 44.43247842742269,
    lng: 8.885916518365267,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-285",
    lat: 44.43247978123374,
    lng: 8.885955310814962,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-286",
    lat: 44.43246867194749,
    lng: 8.885987188662957,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-287",
    lat: 44.43371561619301,
    lng: 8.88586330127748,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-288",
    lat: 44.43367023117908,
    lng: 8.885895490751611,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-289",
    lat: 44.43367656605689,
    lng: 8.88591501182751,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-290",
    lat: 44.433912567678746,
    lng: 8.88591086930113,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-291",
    lat: 44.434352037949516,
    lng: 8.88584240084332,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-292",
    lat: 44.434326958007716,
    lng: 8.88584700279149,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-293",
    lat: 44.43431525794913,
    lng: 8.885861408953875,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-294",
    lat: 44.434239817694454,
    lng: 8.885752394557302,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-295",
    lat: 44.434295234468756,
    lng: 8.885886299855636,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-296",
    lat: 44.434282949569806,
    lng: 8.885863312764142,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-297",
    lat: 44.43427756368569,
    lng: 8.885865892357652,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-298",
    lat: 44.43428822260657,
    lng: 8.88590463976819,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-299",
    lat: 44.434283570447946,
    lng: 8.885912792029345,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-300",
    lat: 44.434644454823435,
    lng: 8.885889339510154,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-301",
    lat: 44.43460082857926,
    lng: 8.885913131909868,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-302",
    lat: 44.434607744296635,
    lng: 8.885928091851047,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-303",
    lat: 44.43505869444595,
    lng: 8.886345743902469,
    type: "pericolo-doppio-senso",
    description: "Pericolo doppio senso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-304",
    lat: 44.43573679330167,
    lng: 8.886862880452234,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-305",
    lat: 44.435872332279914,
    lng: 8.886947027086617,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-306",
    lat: 44.43635396931197,
    lng: 8.887153916608426,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-307",
    lat: 44.43633002320013,
    lng: 8.886948968577633,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-308",
    lat: 44.43639970503728,
    lng: 8.886971786531989,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-309",
    lat: 44.43664504151608,
    lng: 8.887133341723299,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-310",
    lat: 44.4366009832084,
    lng: 8.887154127608701,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-311",
    lat: 44.436667059420394,
    lng: 8.88705860697711,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-312",
    lat: 44.436646175439925,
    lng: 8.887046853879188,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-313",
    lat: 44.436588264177395,
    lng: 8.887140211517844,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-314",
    lat: 44.436582887625235,
    lng: 8.887139736442965,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-315",
    lat: 44.43661070000796,
    lng: 8.887043329886643,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-316",
    lat: 44.436572466034,
    lng: 8.88713281530943,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-317",
    lat: 44.436570043022336,
    lng: 8.887133808193491,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-318",
    lat: 44.43652703435587,
    lng: 8.887213411253775,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-319",
    lat: 44.43657424824481,
    lng: 8.88714211846691,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-320",
    lat: 44.43661216712272,
    lng: 8.887055575824455,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-321",
    lat: 44.43657112440618,
    lng: 8.887141917204323,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-322",
    lat: 44.43663138471557,
    lng: 8.887065069303866,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-323",
    lat: 44.43693593246331,
    lng: 8.887135522491015,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-324",
    lat: 44.43690721545868,
    lng: 8.887124964284586,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-325",
    lat: 44.43699519918122,
    lng: 8.887134882463616,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-326",
    lat: 44.43689673833336,
    lng: 8.887136365761673,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-327",
    lat: 44.43686312482995,
    lng: 8.887290475535153,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-328",
    lat: 44.436943835808044,
    lng: 8.887272240937587,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-329",
    lat: 44.43690374289753,
    lng: 8.887272665450608,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-330",
    lat: 44.436958535023386,
    lng: 8.887142638753929,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-331",
    lat: 44.436954824326264,
    lng: 8.88714885917957,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-332",
    lat: 44.436934999506235,
    lng: 8.887274207138628,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-333",
    lat: 44.4369149848837,
    lng: 8.887284057227406,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-334",
    lat: 44.4368997370342,
    lng: 8.887275908268398,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-335",
    lat: 44.436924489283115,
    lng: 8.887271755748298,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-336",
    lat: 44.43725302135451,
    lng: 8.887523282428427,
    type: "divieto-sosta",
    description: "Divieto sosta",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-337",
    lat: 44.437535871664004,
    lng: 8.88743154908709,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-338",
    lat: 44.43724505334315,
    lng: 8.88752094424075,
    type: "divieto-sosta",
    description: "Divieto sosta",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-339",
    lat: 44.43750439182411,
    lng: 8.887403456300813,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-340",
    lat: 44.43731182974505,
    lng: 8.887551501785081,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-341",
    lat: 44.437493003345615,
    lng: 8.887408372162252,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-342",
    lat: 44.437490398121184,
    lng: 8.887439991062395,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-343",
    lat: 44.437543593936944,
    lng: 8.8876128158994,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-344",
    lat: 44.43749478749999,
    lng: 8.887437067464614,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-345",
    lat: 44.437487089609405,
    lng: 8.887455932316165,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-346",
    lat: 44.43752304166104,
    lng: 8.887607039518624,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-347",
    lat: 44.43750101592665,
    lng: 8.887611642902348,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-348",
    lat: 44.43791573675618,
    lng: 8.887650573795598,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-349",
    lat: 44.437959024072995,
    lng: 8.887667885377663,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-350",
    lat: 44.43782988070169,
    lng: 8.88765343432899,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-351",
    lat: 44.43756548222977,
    lng: 8.88759825169303,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-352",
    lat: 44.43788989950821,
    lng: 8.887680057371728,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-353",
    lat: 44.43784555021805,
    lng: 8.887677999918466,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-354",
    lat: 44.43780947645823,
    lng: 8.887685511920026,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-355",
    lat: 44.437765268163965,
    lng: 8.88767415564585,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-356",
    lat: 44.437760791074034,
    lng: 8.887670353869016,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-357",
    lat: 44.43788485754478,
    lng: 8.88769237885429,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-358",
    lat: 44.43787390208508,
    lng: 8.887711840135928,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-359",
    lat: 44.43786465004201,
    lng: 8.887706675131058,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-360",
    lat: 44.43780419119042,
    lng: 8.887677561199842,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-361",
    lat: 44.4380779443114,
    lng: 8.88809843445919,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-362",
    lat: 44.44040748844883,
    lng: 8.888359249983754,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-363",
    lat: 44.4404107486145,
    lng: 8.888358134910057,
    type: "divieto-sorpasso-auto",
    description: "Divieto sorpasso auto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-364",
    lat: 44.440685244164705,
    lng: 8.888254397747092,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-365",
    lat: 44.44070777504152,
    lng: 8.888183553384632,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-366",
    lat: 44.4409818455604,
    lng: 8.887905444818676,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-367",
    lat: 44.44237811598137,
    lng: 8.887766643968972,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-368",
    lat: 44.44238946580467,
    lng: 8.88778492846721,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-369",
    lat: 44.44246014832715,
    lng: 8.887651630763846,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-370",
    lat: 44.44235240059719,
    lng: 8.88779086825078,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-371",
    lat: 44.44241175669358,
    lng: 8.887663000455053,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-372",
    lat: 44.4423503640639,
    lng: 8.88779803886917,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-373",
    lat: 44.4426734120505,
    lng: 8.888173328870744,
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-374",
    lat: 44.44378277820758,
    lng: 8.88824657602791,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-375",
    lat: 44.44375752266659,
    lng: 8.888287905133426,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-376",
    lat: 44.4438568156134,
    lng: 8.88833370083397,
    type: "divieto-accesso",
    description: "Divieto accesso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-377",
    lat: 44.4465242905572,
    lng: 8.889230926801673,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-378",
    lat: 44.44643447011949,
    lng: 8.889250084960217,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-379",
    lat: 44.446299981424445,
    lng: 8.88939679209764,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-380",
    lat: 44.44652423961857,
    lng: 8.889533946568474,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-381",
    lat: 44.44651626009884,
    lng: 8.88952940378349,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-382",
    lat: 44.44649683314819,
    lng: 8.889516372607728,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-383",
    lat: 44.4465052638231,
    lng: 8.889521749950275,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-384",
    lat: 44.446471965951204,
    lng: 8.889519076331537,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-385",
    lat: 44.44647513581947,
    lng: 8.889519128395591,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-386",
    lat: 44.44652508570787,
    lng: 8.889817793585141,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-387",
    lat: 44.44701756663976,
    lng: 8.889561943024546,
    type: "divieto-accesso",
    description: "Divieto accesso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-388",
    lat: 44.44652029244446,
    lng: 8.889858519339823,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-389",
    lat: 44.446569497328795,
    lng: 8.889791551226466,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-390",
    lat: 44.446652220305246,
    lng: 8.889629547735167,
    type: "obbligo-passaggio-dx",
    description: "Obbligo passaggio dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-391",
    lat: 44.446607850693084,
    lng: 8.889550235416893,
    type: "obbligo-passaggio-dx",
    description: "Obbligo passaggio dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-392",
    lat: 44.44700848888725,
    lng: 8.88991703010099,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-393",
    lat: 44.446539428636996,
    lng: 8.889846494303459,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-394",
    lat: 44.44662877689411,
    lng: 8.889658248026983,
    type: "obbligo-passaggio-dx",
    description: "Obbligo passaggio dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-395",
    lat: 44.446930946790395,
    lng: 8.890007174687211,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-396",
    lat: 44.446838364976884,
    lng: 8.890041617462344,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-397",
    lat: 44.44652327065604,
    lng: 8.889835211599104,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-398",
    lat: 44.44652146702337,
    lng: 8.889817052447988,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-399",
    lat: 44.446503496577094,
    lng: 8.889836932792559,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-400",
    lat: 44.44650285550907,
    lng: 8.889832831740927,
    type: "rotatoria",
    description: "Rotatoria",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-401",
    lat: 44.44497142363452,
    lng: 8.889340712661964,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-402",
    lat: 44.445053241550156,
    lng: 8.889337734890573,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-403",
    lat: 44.444888735832755,
    lng: 8.889272385142645,
    type: "dare-precedenza",
    description: "Dare precedenza",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-404",
    lat: 44.44320847091013,
    lng: 8.889281341090552,
    type: "divieto-sorpasso-auto",
    description: "Divieto sorpasso auto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-405",
    lat: 44.44060284683115,
    lng: 8.88937546122159,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-406",
    lat: 44.44048897940152,
    lng: 8.889353686128468,
    type: "divieto-transito",
    description: "Divieto transito",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-407",
    lat: 44.43960986659906,
    lng: 8.889471348507424,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-408",
    lat: 44.43958700674415,
    lng: 8.88943280149369,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-409",
    lat: 44.439577379392695,
    lng: 8.88938391579538,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-410",
    lat: 44.43942237254294,
    lng: 8.889424178123091,
    type: "pericolo-lavori-in-corso",
    description: "Pericolo lavori in corso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-411",
    lat: 44.43927213376131,
    lng: 8.889405547620399,
    type: "divieto-accesso",
    description: "Divieto accesso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-412",
    lat: 44.43903860999778,
    lng: 8.88945114350798,
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-413",
    lat: 44.438069672777345,
    lng: 8.889348945414774,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-414",
    lat: 44.43809374711615,
    lng: 8.889349465713762,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-415",
    lat: 44.438106017993675,
    lng: 8.88935388231082,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-416",
    lat: 44.43810415682658,
    lng: 8.889371789321556,
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-417",
    lat: 44.43800010765206,
    lng: 8.889395536399741,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-418",
    lat: 44.43790286468628,
    lng: 8.889320863393438,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-419",
    lat: 44.43788638660099,
    lng: 8.8894710527393,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-420",
    lat: 44.437883183426386,
    lng: 8.889369608690897,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-421",
    lat: 44.4378850572543,
    lng: 8.889466284966362,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-422",
    lat: 44.43788801274003,
    lng: 8.889466986078236,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-423",
    lat: 44.43788943669098,
    lng: 8.88946727188517,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-424",
    lat: 44.437886052800664,
    lng: 8.889460771514615,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-425",
    lat: 44.437883676111575,
    lng: 8.889365550725813,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-426",
    lat: 44.43788272818252,
    lng: 8.889456958671273,
    type: "lanterna-semaforica",
    description: "Lanterna semaforica",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-427",
    lat: 44.43751749495039,
    lng: 8.889474539793605,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-428",
    lat: 44.43742953624276,
    lng: 8.88932881505872,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-429",
    lat: 44.436918759824835,
    lng: 8.88930029159755,
    type: "parcheggio",
    description: "Parcheggio",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-430",
    lat: 44.43642559696882,
    lng: 8.889310433193282,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-431",
    lat: 44.43644932980652,
    lng: 8.88930420395839,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-432",
    lat: 44.43644771600978,
    lng: 8.889309707835782,
    type: "pericolo",
    description: "Pericolo",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-433",
    lat: 44.43631912275279,
    lng: 8.889190269642306,
    type: "obbligo-direzione-dx",
    description: "Obbligo direzione dx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-434",
    lat: 44.435083195294,
    lng: 8.889573169898693,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-435",
    lat: 44.43511818143889,
    lng: 8.889486602722913,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-436",
    lat: 44.43508574330808,
    lng: 8.889372892342703,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-437",
    lat: 44.43511007478532,
    lng: 8.889476867914391,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-438",
    lat: 44.435110604348296,
    lng: 8.889345349378619,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-439",
    lat: 44.43513217376979,
    lng: 8.88943703403838,
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-440",
    lat: 44.43482200230201,
    lng: 8.889404135530304,
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-441",
    lat: 44.43482830329588,
    lng: 8.88940362928196,
    type: "divieto-sorpasso-auto",
    description: "Divieto sorpasso auto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-442",
    lat: 44.432401344516244,
    lng: 8.88945112875312,
    type: "divieto-accesso",
    description: "Divieto accesso",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-443",
    lat: "",
    lng: "",
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-444",
    lat: "",
    lng: "",
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-445",
    lat: "",
    lng: "",
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-446",
    lat: "",
    lng: "",
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-447",
    lat: "",
    lng: "",
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-448",
    lat: "",
    lng: "",
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-449",
    lat: "",
    lng: "",
    type: "obbligo-direzione-diritto",
    description: "Obbligo direzione diritto",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-450",
    lat: "",
    lng: "",
    type: "obbligo-passaggio-dx-sx",
    description: "Obbligo passaggio dx sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-451",
    lat: "",
    lng: "",
    type: "pericolo-dosso/cunetta/strada-dissestata",
    description: "Pericolo dosso/cunetta/strada dissestata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-452",
    lat: "",
    lng: "",
    type: "pericolo-dosso/cunetta/strada-dissestata",
    description: "Pericolo dosso/cunetta/strada dissestata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-453",
    lat: "",
    lng: "",
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-454",
    lat: "",
    lng: "",
    type: "pericolo-dosso/cunetta/strada-dissestata",
    description: "Pericolo dosso/cunetta/strada dissestata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-455",
    lat: "",
    lng: "",
    type: "pericolo-dosso/cunetta/strada-dissestata",
    description: "Pericolo dosso/cunetta/strada dissestata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-456",
    lat: "",
    lng: "",
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-457",
    lat: "",
    lng: "",
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-458",
    lat: "",
    lng: "",
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-459",
    lat: "",
    lng: "",
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-460",
    lat: "",
    lng: "",
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-461",
    lat: "",
    lng: "",
    type: "attraversamento-pedonale",
    description: "Attraversamento pedonale",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-462",
    lat: "",
    lng: "",
    type: "divieto-sosta-fermata",
    description: "Divieto sosta fermata",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-463",
    lat: "",
    lng: "",
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-464",
    lat: "",
    lng: "",
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-465",
    lat: "",
    lng: "",
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-466",
    lat: "",
    lng: "",
    type: "obbligo-passaggio-sx",
    description: "Obbligo passaggio sx",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-467",
    lat: "",
    lng: "",
    type: "limite-vel-30",
    description: "Limite vel 30",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-468",
    lat: "",
    lng: "",
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-469",
    lat: "",
    lng: "",
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
  {
    id: "ts-470",
    lat: "",
    lng: "",
    type: "passo-carrabile",
    description: "Passo carrabile",
    image_url: require("../assets/signs/no_entry.png"),
    street: "",
    lastInspection: "",
    condition: "",
  },
];
export const signTypes = {
  // Stop signs
  "stop": {
    iconUrl: require("../assets/textures/stop.png"),
    value: "stop"
  },
  "stop-so": {
    iconUrl: require("../assets/textures/stop-so.png"),
    value: "stop so"
  },

  // Divieto (Prohibition) signs
  "divieto-accesso": {
    iconUrl: require("../assets/textures/divieto-accesso.png"),
    value: "divieto accesso",
  },
  "divieto-sosta": {
    iconUrl: require("../assets/textures/divieto-sosta.png"),
    value: "divieto sosta",
  },
  "divieto-sosta-fermata": {
    iconUrl: require("../assets/textures/divieto-sosta-fermata.png"),
    value: "divieto sosta fermata",
  },
  "divieto-sorpasso-auto": {
    iconUrl: require("../assets/textures/divieto-sorpasso-auto.png"),
    value: "divieto sorpasso auto",
  },
  "divieto-sorpasso-autocarri": {
    iconUrl: require("../assets/textures/divieto-sorpasso-autocarri.png"),
    value: "divieto sorpasso autocarri",
  },
  "divieto-transito": {
    iconUrl: require("../assets/textures/divieto-transito.png"),
    value: "divieto transito",
  },
  "divieto-transito-autocarri": {
    iconUrl: require("../assets/textures/divieto-transito-autocarri.png"),
    value: "divieto transito autocarri",
  },
  "divieto-transito-limite-altezza": {
    iconUrl: require("../assets/textures/divieto-transito-limite-altezza.png"),
    value: "divieto transito limite altezza",
  },
  "divieto-transito-limite-larghezza": {
    iconUrl: require("../assets/textures/divieto-transito-limite-larghezza.png"),
    value: "divieto transito limite larghezza",
  },
  "divieto-transito-limite-peso": {
    iconUrl: require("../assets/textures/divieto-transito-limite-peso.png"),
    value: "divieto transito limite peso",
  },

  // Obbligo (Obligation) signs
  "obbligo-direzione-diritto": {
    iconUrl: require("../assets/textures/obbligo-direzione-diritto.png"),
    value: "obbligo direzione diritto",
  },
  "obbligo-direzione-diritto-dx": {
    iconUrl: require("../assets/textures/obbligo-direzione-diritto-dx.png"),
    value: "obbligo direzione diritto dx",
  },
  "obbligo-direzione-diritto-sx": {
    iconUrl: require("../assets/textures/obbligo-direzione-diritto-sx.png"),
    value: "obbligo direzione diritto sx",
  },
  "obbligo-direzione-dx": {
    iconUrl: require("../assets/textures/obbligo-direzione-dx.png"),
    value: "obbligo direzione dx",
  },
  "obbligo-direzione-sx": {
    iconUrl: require("../assets/textures/obbligo-direzione-sx.png"),
    value: "obbligo direzione sx",
  },
  "obbligo-direzione-dx-sx": {
    iconUrl: require("../assets/textures/obbligo-direzione-dx-sx.png"),
    value: "obbligo direzione dx sx",
  },
  "obbligo-passaggio-dx": {
    iconUrl: require("../assets/textures/obbligo-passaggio-dx.png"),
    value: "obbligo passaggio dx",
  },
  "obbligo-passaggio-sx": {
    iconUrl: require("../assets/textures/obbligo-passaggio-sx.png"),
    value: "obbligo passaggio sx",
  },
  "obbligo-passaggio-dx-sx": {
    iconUrl: require("../assets/textures/obbligo-passaggio-dx-sx.png"),
    value: "obbligo passaggio dx sx",
  },
  "obbligo-dare-precedenza-senso-unico-alternato": {
    iconUrl: require("../assets/textures/obbligo-dare-precedenza-senso-unico-alternato.png"),
    value: "obbligo dare precedenza senso unico alternato",
  },

  // Pericolo (Danger/Warning) signs
  "pericolo": {
    iconUrl: require("../assets/textures/pericolo.png"),
    value: "pericolo",
  },
  "pericolo-strettoia-dx": {
    iconUrl: require("../assets/textures/pericolo-strettoia-dx.png"),
    value: "pericolo strettoia dx",
  },
  "pericolo-strettoia-sx": {
    iconUrl: require("../assets/textures/pericolo-strettoia-sx.png"),
    value: "pericolo strettoia sx",
  },
  "pericolo-strettoia-dx-sx": {
    iconUrl: require("../assets/textures/pericolo-strettoia-dx-sx.png"),
    value: "pericolo strettoia dx sx",
  },
  "pericolo-lavori-in-corso": {
    iconUrl: require("../assets/textures/pericolo-lavori-in-corso.png"),
    value: "pericolo lavori in corso",
  },
  "pericolo-lanterna-semaforica": {
    iconUrl: require("../assets/textures/pericolo-lanterna-semaforica.png"),
    value: "pericolo lanterna semaforica",
  },
  "pericolo-strada-sdrucciolevole": {
    iconUrl: require("../assets/textures/pericolo-strada-sdrucciolevole.png"),
    value: "pericolo strada sdrucciolevole",
  },
  "pericolo-intersezione-con-precedenza-dx": {
    iconUrl: require("../assets/textures/pericolo-intersezione-con-precedenza-dx.png"),
    value: "pericolo intersezione con precedenza dx",
  },
  "pericolo-intersezione-con-precedenza-sx": {
    iconUrl: require("../assets/textures/pericolo-intersezione-con-precedenza-sx.png"),
    value: "pericolo intersezione con precedenza sx",
  },
  "pericolo-intersezione-con-precedenza-dx-sx": {
    iconUrl: require("../assets/textures/pericolo-intersezione-con-precedenza-dx-sx.png"),
    value: "pericolo intersezione con precedenza dx sx",
  },
  "pericolo-dosso_cunetta_strada-dissestata": {
    iconUrl: require("../assets/textures/pericolo-dosso_cunetta_strada-dissestata.png"),
    value: "pericolo dosso cunetta strada dissestata",
  },
  "pericolo-doppio-senso": {
    iconUrl: require("../assets/textures/pericolo-doppio-senso.png"),
    value: "pericolo doppio senso",
  },
  "pericolo-doppia-curva-dx": {
    iconUrl: require("../assets/textures/pericolo-doppia-curva-dx.png"),
    value: "pericolo doppia curva dx",
  },
  "pericolo-doppia-curva-sx": {
    iconUrl: require("../assets/textures/pericolo-doppia-curva-sx.png"),
    value: "pericolo doppia curva sx",
  },
  "pericolo-attraversamento-pedonale": {
    iconUrl: require("../assets/textures/pericolo-attraversamento-pedonale.png"),
    value: "pericolo attraversamento pedonale",
  },

  // Limite velocità (Speed limit) signs
  "limite-vel-20": {
    iconUrl: require("../assets/textures/limite-vel-20.png"),
    value: "limite vel 20",
  },
  "limite-vel-30": {
    iconUrl: require("../assets/textures/limite-vel-30.png"),
    value: "limite vel 30",
  },
  "limite-vel-40": {
    iconUrl: require("../assets/textures/limite-vel-40.png"),
    value: "limite vel 40",
  },
  "limite-vel-50": {
    iconUrl: require("../assets/textures/limite-vel-50.png"),
    value: "limite vel 50",
  },
  "limite-vel-60": {
    iconUrl: require("../assets/textures/limite-vel-60.png"),
    value: "limite vel 60",
  },
  "limite-vel-70": {
    iconUrl: require("../assets/textures/limite-vel-70.png"),
    value: "limite vel 70",
  },
  "limite-vel-80": {
    iconUrl: require("../assets/textures/limite-vel-80.png"),
    value: "limite vel 80",
  },

  // Parcheggio (Parking) signs
  "parcheggio": {
    iconUrl: require("../assets/textures/parcheggio.png"),
    value: "parcheggio",
  },
  "parcheggio-disabili-so": {
    iconUrl: require("../assets/textures/parcheggio-disabili-so.png"),
    value: "parcheggio disabili so",
  },
  "parcheggio-merci-so": {
    iconUrl: require("../assets/textures/parcheggio-merci-so.png"),
    value: "parcheggio merci so",
  },

  // Other traffic signs
  "attraversamento-pedonale": {
    iconUrl: require("../assets/textures/attraversamento-pedonale.png"),
    value: "attraversamento pedonale",
  },
  "attraversamento-pedonale-so": {
    iconUrl: require("../assets/textures/attraversamento-pedonale-so.png"),
    value: "attraversamento pedonale so",
  },
  "dare-precedenza": {
    iconUrl: require("../assets/textures/dare-precedenza.png"),
    value: "dare precedenza",
  },
  "dare-precedenza-so": {
    iconUrl: require("../assets/textures/dare-precedenza-so.png"),
    value: "dare precedenza so",
  },
  "diritto-precedenza-senso-unico-alternato": {
    iconUrl: require("../assets/textures/diritto-precedenza-senso-unico-alternato.png"),
    value: "diritto precedenza senso unico alternato",
  },
  "dosso-so": {
    iconUrl: require("../assets/textures/dosso-so.png"),
    value: "dosso so",
  },
  "fermata-bus-so": {
    iconUrl: require("../assets/textures/fermata-bus-so.png"),
    value: "fermata bus so",
  },
  "lanterna-semaforica": {
    iconUrl: require("../assets/textures/lanterna-semaforica.png"),
    value: "lanterna semaforica",
  },
  "passo-carrabile": {
    iconUrl: require("../assets/textures/passo-carrabile.png"),
    value: "passo carrabile",
  },
  "rotatoria": {
    iconUrl: require("../assets/textures/rotatoria.png"),
    value: "rotatoria",
  },
  "senso-unico-dx": {
    iconUrl: require("../assets/textures/senso-unico-dx.png"),
    value: "senso unico dx",
  },
  "senso-unico-sx": {
    iconUrl: require("../assets/textures/senso-unico-sx.png"),
    value: "senso unico sx",
  },
  "strada-senza-sbocco": {
    iconUrl: require("../assets/textures/strada-senza-sbocco.png"),
    value: "strada senza sbocco",
  },
};
